import React from 'react';

const Error = () => {
  const title = 'This is the error page';
  const msg = 'Welcome';

  return (
    <>
      <h1>{title}</h1>
      <p>{msg}</p>
    </>
  );
};

export default Error;
